var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.441406)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9108",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.441406",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9108)" } }, [
        _c("path", {
          attrs: {
            d: "M46.4414 46.0006L46.4414 0L0.440941 0L0.440941 46.0006L46.4414 46.0006Z",
            fill: "#B42A8A",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.441406 46.0006V0.222656L46.2192 46.0006H0.441406Z",
            fill: "#D064B6",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }